import z from "zod";

export const otherParamsSchema = z
  .object({
    addReminder: z.boolean().optional(),
    editPlanEvent: z.number().optional(),
    addPlanEvent: z
      .object({
        startDate: z.date(),
        endDate: z.date()
      })
      .optional(),
    editNote: z.number().optional(),
    editChecklist: z.number().optional()
  })
  .nullable();

export type EntityManagerOtherParams = z.infer<typeof otherParamsSchema>;